import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useGetCateringRequestByIdQuery } from '../../redux/slices/cateringRequestSlice';
import useAuth from '../../hooks/useAuth';

function RequireCateringUser({ children, redirectTo = '/login' }) {
  const { request_id } = useParams();
  const { auth } = useAuth();
  const skipRequest = !request_id || !auth.initialized;

  const { data: cateringRequest, isSuccess } = useGetCateringRequestByIdQuery(
    request_id,
    { skip: skipRequest },
  );
  const requestComplete = skipRequest || isSuccess;

  if (!auth.initialized || !requestComplete) {
    return null;
  }

  const isAdmin = auth.loggedIn && auth.userData.admin;
  const isCateringUser = !isAdmin && auth.loggedIn && auth.userData.catering_user;
  const isVendorUser = !isAdmin && !isCateringUser && auth.loggedIn;

  let redirectLink = redirectTo;
  if (isVendorUser) {
    redirectLink = '/vendor';
  }

  // Check that this user owns this catering request
  let userOwnsRequest = true;
  if (isCateringUser && request_id) {
    if (!cateringRequest || cateringRequest.user.id !== auth.userData.id) {
      userOwnsRequest = false;
    }
  }

  return (isAdmin || (isCateringUser && userOwnsRequest)) ? children : <Redirect to={redirectLink}/>;
}

export default RequireCateringUser;
